import { useContext } from 'react';
import { IndexContext } from './IndexContext.js';
import { invariant } from './invariant.js';

function useIndexContext() {
    var context = useContext(IndexContext);
    invariant(context !== null);
    return context;
}

export { useIndexContext };
